import React, { useState ,useEffect, useReducer } from 'react'
import { BrowserRouter, Link, Redirect, useLocation } from 'react-router-dom'
import ScrollToTop from "./components/utils/ScrollToTop"
import LaunchScreen from "./components/utils/LaunchScreen"

import Router from './Router'
import contactsContext from "./dataManager/contactsContext"
import { saveAllContacts } from "./dataManager/contacts/actions"
import contactsReducer from "./dataManager/contacts/contactsReducer"

function App() {

  const [ready, setReady] = useState(false)

  const [contacts, dispatshContacts] = useReducer(contactsReducer, [])

  useEffect(() => {
    let timer = setTimeout(() => setReady(true), 500) 

    return () => {
      clearTimeout(timer)
    }
  }, [])


  const contactsSaveAllContacts = (datas) => {
    dispatshContacts(saveAllContacts(datas))
  }

  const contextValue = {
    contacts,
    saveAllContacts: contactsSaveAllContacts
  }

  return (
    <contactsContext.Provider value={contextValue}>
      <BrowserRouter>
        <ScrollToTop />
        { ready? <Router /> : <LaunchScreen /> }
      </BrowserRouter> 
    </contactsContext.Provider>
  );
}
export default App
